enum BatchStatus {
    Created = 'Created',
    VerifyingFunds = 'VerifyingFunds',
    AwaitingFunding = 'AwaitingFunding',
    FundingApproved = 'FundingApproved',
    FundingReceived = 'FundingReceived',
    AwaitingApprovalForExport = 'AwaitingApprovalForExport',
    ExportApproved = 'ExportApproved',
    AwaitingDataControlApproval = 'AwaitingDataControlApproval',
    Cancelled = 'Cancelled',
    Sent = 'Sent',
    Cancelling = 'Cancelling',
}

export default BatchStatus;
